import {svgIconWrapper} from '../svg-icon-wrapper';

import Flask from './flask-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <Flask {...props} />;
}
SvgComponent.iconName = 'flask';

export const FlaskIcon = svgIconWrapper(SvgComponent);
